import axios from 'axios';

// Define state
const state = {
  id: 0,
  accountId: localStorage.getItem('accountId') || '',
  companyName: localStorage.getItem('companyname') || '',
  role: localStorage.getItem('role') || '',
  username: '',
  fullname: '',
  token: localStorage.getItem('userToken') || '',
};

// Define mutations
const mutations = {
  SET_USER(state, { id, accountId, companyname, username, fullname, role }) {
    state.id = id;
    state.username = fullname;

    // Save user data to local storage
    localStorage.setItem('userId', id);
    localStorage.setItem('accountId', accountId);
    localStorage.setItem('companyname', companyname);
    localStorage.setItem('username', username);
    localStorage.setItem('fullname', fullname);
    localStorage.setItem('role', role);
  },
  SET_TOKEN(state, token) {
    state.token = token;
    localStorage.setItem('userToken', token);
  },
  CLEAR_USER(state) {
    state.id = null;
    state.username = '';
    state.fullname = '';
    state.role='';
    state.token = '';


    // Clear user data from local storage
    localStorage.removeItem('accountId');
    localStorage.removeItem('userId');
    localStorage.removeItem('fullname');
    localStorage.removeItem('username');
    localStorage.removeItem('userToken');
    // localStorage.removeItem('theme');
    // localStorage.removeItem('language');
    localStorage.removeItem('companyname'); 
    localStorage.removeItem('role');
  },
};

// Define actions
const actions = {
  async login({ commit }, { username, password }) {
    try {
      const baseUrl = process.env.VUE_APP_API_BASE_URL || 'https://localhost:3000';
      const response = await axios.post(`${baseUrl}/auth`, {
        usernameOrEmail: username,
        password: password,
      }, {
        headers: {
          'Content-Type': 'application/json',
        }
      });

      console.log('Login response:', response.data);

      const { token, user } = response.data;

      // Commit the user and token to the Vuex store
      commit('SET_USER', { id: user.id, accountId: user.accountId, companyname: user.companyName, username: user.username, fullname: user.fullname, role: user.role });
      commit('SET_TOKEN', token);
      
      return response.data; 
    } catch (error) {
      console.error('Error logging in:', error);
      if (error.response) {
        console.error('Server responded with status:', error.response.status);
        console.error('Error details:', error.response.data);
      }
      throw error;
    }
  },
  logout({ commit }) {
    commit('CLEAR_USER');
  },
};

const getters = {
  isLoggedIn: state => !!state.token,
};

// Export the module
export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};